import * as Types from '../../../../../../generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HeaderBannerDataQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type HeaderBannerDataQuery = (
  { __typename?: 'Query' }
  & { userSubscriptions?: Types.Maybe<(
    { __typename?: 'UserSubscriptionConnection' }
    & { nodes: Array<Types.Maybe<(
      { __typename?: 'UserSubscription' }
      & Pick<Types.UserSubscription, 'rowId' | 'active' | 'userId' | 'amount' | 'total' | 'initialNuveiTransactionId' | 'createdAt' | 'updatedAt' | 'rebillDate' | 'lastRenewalDate'>
    )>> }
  )>, savedCards?: Types.Maybe<(
    { __typename?: 'SavedCardConnection' }
    & { nodes: Array<Types.Maybe<(
      { __typename?: 'SavedCard' }
      & Pick<Types.SavedCard, 'rowId' | 'maskedCardNumber' | 'userId'>
    )>> }
  )>, users?: Types.Maybe<(
    { __typename?: 'UserConnection' }
    & { nodes: Array<Types.Maybe<(
      { __typename?: 'User' }
      & { nuveiSavedCards: (
        { __typename?: 'NuveiSavedCardConnection' }
        & { nodes: Array<Types.Maybe<(
          { __typename?: 'NuveiSavedCard' }
          & Pick<Types.NuveiSavedCard, 'rowId' | 'cardNumber' | 'userId'>
        )>> }
      ) }
    )>> }
  )> }
);


export const HeaderBannerDataDocument = gql`
    query HeaderBannerData($userId: Int!) {
  userSubscriptions(filter: {userId: {equalTo: $userId}}) {
    nodes {
      rowId
      active
      userId
      amount
      total
      initialNuveiTransactionId
      createdAt
      updatedAt
      rebillDate
      lastRenewalDate
    }
  }
  savedCards(filter: {userId: {equalTo: $userId}}, first: 50) {
    nodes {
      rowId
      maskedCardNumber
      userId
    }
  }
  users(filter: {rowId: {equalTo: $userId}}) {
    nodes {
      nuveiSavedCards(first: 50) {
        nodes {
          rowId
          cardNumber
          userId
        }
      }
    }
  }
}
    `;

/**
 * __useHeaderBannerDataQuery__
 *
 * To run a query within a React component, call `useHeaderBannerDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaderBannerDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaderBannerDataQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useHeaderBannerDataQuery(baseOptions: Apollo.QueryHookOptions<HeaderBannerDataQuery, HeaderBannerDataQueryVariables> & ({ variables: HeaderBannerDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaderBannerDataQuery, HeaderBannerDataQueryVariables>(HeaderBannerDataDocument, options);
      }
export function useHeaderBannerDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaderBannerDataQuery, HeaderBannerDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaderBannerDataQuery, HeaderBannerDataQueryVariables>(HeaderBannerDataDocument, options);
        }
// @ts-ignore
export function useHeaderBannerDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HeaderBannerDataQuery, HeaderBannerDataQueryVariables>): Apollo.UseSuspenseQueryResult<HeaderBannerDataQuery, HeaderBannerDataQueryVariables>;
export function useHeaderBannerDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HeaderBannerDataQuery, HeaderBannerDataQueryVariables>): Apollo.UseSuspenseQueryResult<HeaderBannerDataQuery | undefined, HeaderBannerDataQueryVariables>;
export function useHeaderBannerDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HeaderBannerDataQuery, HeaderBannerDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HeaderBannerDataQuery, HeaderBannerDataQueryVariables>(HeaderBannerDataDocument, options);
        }
export type HeaderBannerDataQueryHookResult = ReturnType<typeof useHeaderBannerDataQuery>;
export type HeaderBannerDataLazyQueryHookResult = ReturnType<typeof useHeaderBannerDataLazyQuery>;
export type HeaderBannerDataSuspenseQueryHookResult = ReturnType<typeof useHeaderBannerDataSuspenseQuery>;
export type HeaderBannerDataQueryResult = Apollo.QueryResult<HeaderBannerDataQuery, HeaderBannerDataQueryVariables>;